<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col gap-4">
    <BaseHeading>{{ t('title') }}</BaseHeading>

    <BaseParagraph>
      {{ t('description') }}
    </BaseParagraph>

    <BaseParagraph>
      {{ t('signUpDescription') }}
    </BaseParagraph>

    <BaseButton to="/signup" color="primary">
      {{ t('signUp') }}
    </BaseButton>

    <BaseButton to="/auth/login-1" color="light">
      {{ t('iAlreadyHaveAnAccount') }}
    </BaseButton>
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "title": "You are not logged in",
    "description": "To use this feature, you must be logged in.",
    "signUpDescription": "Luckily, it's very easy to create an account. It takes less than 2 minutes.",
    "signUp": "Sign up",
    "iAlreadyHaveAnAccount": "I already have an account"
  },
  "nl": {
    "title": "Je bent niet ingelogd",
    "description": "Om deze functie te gebruiken moet je ingelogd zijn.",
    "signUp": "Aanmelden",
    "signUpDescription": "Gelukkig is het heel makkelijk om een account te maken. Het duurt minder dan 2 minuten.",
    "iAlreadyHaveAnAccount": "Ik heb al een account"
  }
}
</i18n>
